module.exports = __webpack_public_path__ + "./docs/img/big-icon-protocol.83dc82ced762cd95accb69aa3abefb21.svg";